import React, { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { CountBadge, HasOwnership } from "components/common";
import EntityShareModal from "components/permissions/EntityShareModal";
import { COLLECTIONS_QUERY_KEY } from "collections/hooks/useCollections";
const SharedWithCell = ({ shared_with, id, title }) => {
  const queryClient = useQueryClient();
  const [showEntityShareModal, setShowEntityShareModal] = useState(false);
  const refetchCollections = useCallback(
    () => queryClient.invalidateQueries({
      queryKey: [COLLECTIONS_QUERY_KEY]
    }),
    [queryClient]
  );
  const toggleEntityShareModal = () => setShowEntityShareModal(!showEntityShareModal);
  const handleShareClose = () => {
    refetchCollections();
    toggleEntityShareModal();
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HasOwnership, { type: "collection_entities", id }, ({ disabled }) => /* @__PURE__ */ React.createElement(CountBadge, { onClick: disabled ? void 0 : toggleEntityShareModal, count: shared_with })), showEntityShareModal && /* @__PURE__ */ React.createElement(
    EntityShareModal,
    {
      entityId: id,
      entityType: "collection_entities",
      entityTypeTitle: "Collection Content",
      entityTitle: title,
      description: "Search for a User or Team to add as collaborator on this collection's content.",
      onClose: handleShareClose
    }
  ));
};
export default SharedWithCell;
